import { render, staticRenderFns } from "./MacrosComponent.vue?vue&type=template&id=6336e91d&scoped=true&"
import script from "./MacrosComponent.vue?vue&type=script&lang=ts&"
export * from "./MacrosComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MacrosComponent.vue?vue&type=style&index=0&id=6336e91d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6336e91d",
  null
  
)

export default component.exports